export const TOPHEADER_ZINDEX = 900;
export const SIDEBAR_ZINDEX = TOPHEADER_ZINDEX - 10;
export const SIDEBAR_MODAL_ZINDEX = SIDEBAR_ZINDEX - 10;
export const SUBHEADER_ZINDEX = SIDEBAR_MODAL_ZINDEX - 10;
export const CATALOG_VEHICLE_HEADER_ZINDEX = SUBHEADER_ZINDEX - 20;
export const TREE_SELECT_ZINDEX = CATALOG_VEHICLE_HEADER_ZINDEX - 10;
export const POPOVER_ZINDEX = 1050;
